import Model from '@/store/plugins/orm/Model';

export class Pricelist extends Model {
    static get entity() {
        return 'pricelists';
    }

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            enabled: this.attr(true),
        };
    }
}

export default Pricelist;
